import { cn } from "../../lib/cn.js";

export function Skeleton({ className, ...props }: React.ComponentProps<"div">): React.JSX.Element {
  return <div className={cn("bg-accent animate-pulse rounded-md", className)} {...props} />;
}
